import React from 'react';
import { Ai2Layout } from '../../../layout/Ai2Layout';

interface ChatHomeLayoutProps {
  children: React.ReactNode;
}

const ChatHomeLayout = ({ children }: ChatHomeLayoutProps) => {
  return (
    <Ai2Layout>
      <div style={{ marginTop: '70px' }} className="d-flex flex-column px-5">
        {children}
      </div>
    </Ai2Layout>
  );
};

export default ChatHomeLayout;
